const semantic = {
    positive120: '#056B42',
    positive100: '#1BAB5D',
    positive70: '#1ADB81',
    positive30: '#74E6AD',
    positive10: '#E8FCF1',
    critical120: '#BB2532',
    critical100: '#E8313A',
    critical70: '#F64C56',
    critical30: '#FF8993',
    critical10: '#FFD1DA',
    warning120: '#A57412',
    warning100: '#FBB104',
    warning70: '#FCC736',
    warning30: '#FDDC72',
    warning10: '#FFF2CC',
    link120: '#104D93',
    link100: '#1268ED',
    link70: '#4C8AF6',
    link30: '#B1CFFB',
    link10: '#E7EEFE',
};
export { semantic };
